import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { UiNodeSpec } from './UiNodeSpec';

export const booleanUiNodeSpec: UiNodeSpec<'boolean'> = {
    inputs: () => ({}),
    validator: () => true,
    requiredSockets: 'all',
    nodeCategory: 'boolean',
    kindLabel: 'Boolean Value',
    cfg: () => ({ controlValues: { value: true }, id: getUID(), kind: 'boolean', disabled: false }),
    outputs: () => ({ output: { socket: 'boolean', label: 'Output' } }),
    controls: getNodeCfg => ({ value: { cfg: { kind: 'boolean', label: 'Value' }, nodeCfg: getNodeCfg(), value: getNodeCfg().controlValues.value } }),
};
